import { render, staticRenderFns } from "./Worth.vue?vue&type=template&id=2fb688c7&scoped=true"
import script from "./Worth.vue?vue&type=script&lang=js"
export * from "./Worth.vue?vue&type=script&lang=js"
import style0 from "./Worth.vue?vue&type=style&index=0&id=2fb688c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb688c7",
  null
  
)

export default component.exports